const GoogleMapPlugin = {
  install (Vue, options) {
    let googlemap = {
      isLoaded: null,
      google: null,
      loadScript: null
    }

    let scriptPath = 'https://maps.googleapis.com/maps/api/js?language=en&libraries=places'
    let apiKey = Vue.env.googleMapAPIKey
    scriptPath += '&key=' + apiKey
    scriptPath += `&channel=3`

    let script = document.createElement('script')
    script.src = scriptPath

    googlemap.loadScript = function (callback) {
      if (googlemap.isLoaded === null) {
        googlemap.isLoaded = false
        script.onload = function () {
          googlemap.isLoaded = true
          googlemap.google = window.google
          callback(new Error(true))
        }
        script.onerror = function () {
          googlemap.isLoaded = false
          callback(new Error(false))
          console.error('Error loading: ' + this.src)
        }
        document.head.appendChild(script)
      }
    }

    Vue.prototype.$googlemap = googlemap
    Vue.googlemap = googlemap
  }
}

export default GoogleMapPlugin



// WEBPACK FOOTER //
// ./src/plugins/googlemap.js